import React from "react";
import { Menu } from "@headlessui/react";
import tw from "twin.macro";
import { MinusCircleIcon } from "@heroicons/react/24/outline";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "@/api/api";
import { showReportModal } from "@/state/reportModal/actions";
import { useDispatch } from "react-redux";
import { showBlockUserModal } from "@/state/blockUserModal/actions";

type Props = {
  userId: string;
  blocked?: boolean;
  keys?: string[];
};

const BlockUserDropdownButton = (props: Props) => {
  const { userId, blocked, keys = [] } = props;
  const queryClient = useQueryClient();

  const dispatch = useDispatch();

  const block = useMutation([`block-${userId}`], {
    mutationFn: async () => {
      const res = await api.get(`/api/v1/users/${userId}/block`);
      return res.data;
    },
    onSuccess: () => {
      keys.forEach((key) => {
        queryClient.invalidateQueries({ queryKey: [key] });
      });
    },
    onError: () => {
      alert("Failed");
    },
  });

  const unblock = useMutation([`unblock-${userId}`], {
    mutationFn: async () => {
      const res = await api.get(`/api/v1/users/${userId}/unblock`);
      return res.data;
    },
    onSuccess: () => {
      keys.forEach((key) => {
        queryClient.invalidateQueries({ queryKey: [key] });
      });
    },
    onError: () => {
      alert("Failed");
    },
  });

  return (
    <Menu.Item>
      {({ active }) => (
        <button
          onClick={(e) => {
            if (blocked) {
              unblock.mutate();
            } else {
              dispatch(showBlockUserModal(userId));
            }
            e.stopPropagation();
          }}
          type="submit"
          css={[
            active ? tw`bg-gray-100 text-gray-900` : tw`text-gray-700`,
            tw`block w-full px-4 py-2 text-left text-sm inline-flex items-center justify-between`,
          ]}
        >
          {blocked ? "Entblockieren" : "Blockieren"}
          <MinusCircleIcon className="w-4 h-4" />
        </button>
      )}
    </Menu.Item>
  );
};

export default BlockUserDropdownButton;
